import type { LocationResponse, LocationData } from '../types';

export default function formatLocationData(
  data: LocationResponse
): Pick<LocationData, 'city' | 'state' | 'zip' | 'accuracyRadius'> {
  const { accuracyRadius, city, zip5: zip } = data;
  const state = data.state ?? data.stateAbbreviation;

  if (!city || !state || !zip) {
    throw new Error('Missing required location data');
  }

  return { accuracyRadius, city, state, zip };
}
